/* THE SUMMIT — product page: gallery, variants, add to cart, sticky buy bar, tabs, breadcrumb */
(function () {
  const rel = document.querySelector('[data-tsdv-rel]');
  if (rel && !rel.children.length) {
    const load = () => fetch(rel.dataset.url).then((r) => r.text()).then((h) => {
      const d = new DOMParser().parseFromString(h, 'text/html').querySelector('[data-tsdv-rel]');
      if (d && d.innerHTML.trim()) rel.innerHTML = d.innerHTML;
    }).catch(() => {});
    (window.requestIdleCallback || ((f) => setTimeout(f, 300)))(load);
  }
})();
(function () {
  const root = document.querySelector('[data-tsdv-pdp]');
  const jsonEl = document.querySelector('[data-tsdv-pdp-json]');
  if (!root || !jsonEl) return;
  const D = JSON.parse(jsonEl.textContent);
  const $ = (sel, el = root) => el.querySelector(sel);
  const $$ = (sel, el = root) => Array.from(el.querySelectorAll(sel));

  /* money */
  const fmt = (cents) => {
    const f = D.moneyFormat || '${{amount}}';
    const n = (cents / 100);
    const two = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(n).toLocaleString('de-DE');
      return two;
    });
  };

  /* gallery */
  const track = $('[data-tsdv-track]');
  const slides = $$('.tsdv-pdp__slide');
  const thumbs = $$('[data-tsdv-thumb-i]');
  const dots = $$('.tsdv-pdp__dots i');
  let cur = 0;
  const go = (i, smooth = true) => {
    if (!slides.length) return;
    cur = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[cur].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    mark(cur);
  };
  const mark = (i) => {
    thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
    dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
  };
  thumbs.forEach((t) => t.addEventListener('click', () => go(+t.dataset.tsdvThumbI)));
  $$('[data-tsdv-step]').forEach((b) => b.addEventListener('click', () => go(cur + +b.dataset.tsdvStep)));
  let st;
  track && track.addEventListener('scroll', () => {
    clearTimeout(st);
    st = setTimeout(() => { cur = Math.round(track.scrollLeft / track.clientWidth); mark(cur); }, 80);
  }, { passive: true });

  /* zoom: hover magnify on desktop, click opens lightbox */
  const lb = document.querySelector('[data-tsdv-lightbox]');
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  $$('.tsdv-pdp__zoom').forEach((z) => {
    const img = z.querySelector('img');
    if (fine && img) {
      z.addEventListener('mousemove', (e) => {
        const r = z.getBoundingClientRect();
        img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
        z.classList.add('is-zoom');
      });
      z.addEventListener('mouseleave', () => z.classList.remove('is-zoom'));
    }
    z.addEventListener('click', () => {
      if (!lb || !lb.showModal) return;
      lb.querySelector('[data-tsdv-lb-img]').src = z.dataset.tsdvZoomSrc;
      lb.showModal();
    });
  });
  if (lb) lb.addEventListener('click', () => lb.close());

  /* variants */
  let variant = D.variants.find((v) => v.id === D.selected) || D.variants[0];
  const opts = $$('[data-tsdv-opt]');
  const addBtns = [$('[data-tsdv-addcart]'), document.querySelector('[data-tsdv-addcart-proxy]')].filter(Boolean);
  const render = () => {
    $('[data-tsdv-now]').textContent = variant ? fmt(variant.price) + (D.currency ? ' ' + D.currency : '') : '';
    const was = $('[data-tsdv-was]'), off = $('[data-tsdv-off]');
    const sale = variant && variant.compare > variant.price;
    was.hidden = off.hidden = !sale;
    if (sale) { was.textContent = fmt(variant.compare); off.textContent = '-' + Math.floor(((variant.compare - variant.price) * 100) / variant.compare) + '%'; }
    const sp = document.querySelector('[data-tsdv-sbuy-price]'); if (sp && variant) sp.textContent = fmt(variant.price);
    const av = $('[data-tsdv-avail]');
    let txt = '', cls = 'ok';
    if (!variant) { txt = D.t.unavail; cls = 'no'; }
    else if (!variant.available) { txt = D.t.soldout; cls = 'no'; }
    else if (variant.tracked === 'shopify' && variant.qty !== null && variant.qty > 0 && variant.qty <= D.low) { txt = `Only ${variant.qty} left in stock`; cls = 'low'; }
    else txt = 'In stock';
    av.textContent = txt; av.dataset.state = cls;
    addBtns.forEach((b) => { b.disabled = !variant || !variant.available; });
    const lbl = $('[data-tsdv-addcart-label]'); if (lbl) lbl.textContent = !variant ? D.t.unavail : variant.available ? D.t.add : D.t.soldout;
    $('[data-tsdv-buynow]').disabled = !variant || !variant.available;
    // availability of each pill given other selections
    opts.forEach((fs, oi) => {
      $$('.tsdv-pdp__pill', fs).forEach((p) => {
        const sel = currentOptions(); sel[oi] = p.dataset.value;
        const m = D.variants.find((v) => v.options.every((o, k) => o === sel[k]));
        p.classList.toggle('is-out', !m || !m.available);
      });
    });
  };
  const currentOptions = () => opts.map((fs) => { const p = $('.tsdv-pdp__pill[aria-pressed="true"]', fs); return p ? p.dataset.value : null; });
  opts.forEach((fs) => {
    $$('.tsdv-pdp__pill', fs).forEach((p) => p.addEventListener('click', () => {
      $$('.tsdv-pdp__pill', fs).forEach((x) => x.setAttribute('aria-pressed', x === p ? 'true' : 'false'));
      $('[data-tsdv-opt-val]', fs).textContent = p.dataset.value;
      const sel = currentOptions();
      variant = D.variants.find((v) => v.options.every((o, k) => o === sel[k]));
      if (variant) {
        const u = new URL(location.href); u.searchParams.set('variant', variant.id);
        history.replaceState(history.state, '', u.toString());
        if (variant.media) { const i = slides.findIndex((s) => +s.dataset.mediaId === variant.media); if (i > -1) go(i); }
      }
      render();
    }));
  });
  render();

  /* quantity */
  const qty = $('[data-tsdv-qty]');
  $$('[data-tsdv-q]').forEach((b) => b.addEventListener('click', () => { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + +b.dataset.tsdvQ); }));

  /* add to cart (Dawn cart drawer) */
  const err = $('[data-tsdv-err]');
  const add = (then) => {
    if (!variant || !variant.available) return Promise.resolve();
    err.hidden = true;
    addBtns.forEach((b) => b.classList.add('is-busy'));
    const drawer = document.querySelector('cart-drawer');
    const body = { items: [{ id: variant.id, quantity: Math.max(1, parseInt(qty.value, 10) || 1) }] };
    if (drawer && !then) { body.sections = drawer.getSectionsToRender().map((s) => s.id); body.sections_url = location.pathname; }
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then((r) => r.json()).then((res) => {
      if (res.status) { err.textContent = res.description || res.message; err.hidden = false; return; }
      if (then) return then();
      if (drawer && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents({ id: variant.id, sections: res.sections }); }
      else location.href = (window.routes && window.routes.cart_url) || '/cart';
      if (window.publish && window.PUB_SUB_EVENTS) window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tsdv-pdp', productVariantId: variant.id });
    }).catch(() => { err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; })
      .finally(() => addBtns.forEach((b) => b.classList.remove('is-busy')));
  };
  addBtns.forEach((b) => b.addEventListener('click', () => add()));
  $('[data-tsdv-buynow]').addEventListener('click', () => add(() => { location.href = '/checkout'; }));

  /* sticky buy bar: shows once the main button leaves the viewport (mobile CSS only) */
  const sbuy = document.querySelector('[data-tsdv-sbuy]');
  const main = $('[data-tsdv-buy]');
  if (sbuy && main) {
    let raf = 0, last = null;
    const check = () => {
      raf = 0;
      const show = main.getBoundingClientRect().bottom < 0;
      if (show === last) return; last = show;
      sbuy.classList.toggle('is-on', show); sbuy.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
    check();
  }

  /* tabs (desktop) / accordions (mobile) */
  const tabs = $$('[data-tsdv-tabs] [role="tab"]');
  const panels = $$('.tsdv-pdp__panel');
  tabs.forEach((t) => t.addEventListener('click', () => {
    tabs.forEach((x) => x.setAttribute('aria-selected', x === t ? 'true' : 'false'));
    panels.forEach((p) => { p.open = p.dataset.panel === t.dataset.tab; });
  }));

  /* reviews: reopen the Reviews tab after the free contact-form submission */
  const rv = $('#tsdv-reviews');
  if (rv && (/contact_posted=true/.test(location.search) || /TsdvReview|tsdv-reviews/.test(location.hash) || rv.querySelector('.tsdv-review__err'))) {
    const tb = tabs.find((x) => x.dataset.tab === 'reviews');
    if (tb) tb.click(); else rv.open = true;
    setTimeout(() => rv.scrollIntoView({ block: 'start', behavior: 'smooth' }), 300);
  }

  /* breadcrumb: prefer the collection the visitor came from */
  const crumb = $('[data-tsdv-crumb-coll]');
  try {
    const ref = document.referrer ? new URL(document.referrer) : null;
    if (crumb && ref && ref.origin === location.origin && !/\/collections\/[^/]+\/products\//.test(location.pathname)) {
      const m = ref.pathname.match(/\/collections\/([^/?#]+)/);
      if (m && D.collections[m[1]]) { crumb.textContent = D.collections[m[1]].t; crumb.href = ref.pathname + ref.search; }
      else if (m && m[1] === 'all') { crumb.textContent = 'All'; crumb.href = ref.pathname + ref.search; }
    }
    // go back in history when the crumb matches where we came from, so scroll position is restored
    if (crumb && ref && ref.origin === location.origin) {
      crumb.addEventListener('click', (e) => {
        if (new URL(crumb.href, location.origin).pathname === ref.pathname && history.length > 1) { e.preventDefault(); history.back(); }
      });
    }
  } catch (e) {}
})();
